import React from 'react'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'
import type { SetOptional } from 'type-fest'
import { productQueries } from './graphql'
import { useProductTooltipPopOverContext } from './Context'
import type { UseDocumentResult } from '@ztechapps/common.hook'
import type { Product } from '@ztechapps/common.contract'

type ProductTooltipPopOverInlineInput = SetOptional<InlineInputProps, 'mutationConfig' | 'initialValues'> & {
  productDocument: UseDocumentResult<Product>
}

export const ProductTooltipPopOverInlineInput = ({
  productDocument,
  parentInputComponent,
  name,
  ...rest
}: ProductTooltipPopOverInlineInput) => {
  const ParentInput = parentInputComponent || InlineInput
  const { canEdit } = useProductTooltipPopOverContext()
  const product = productDocument?.document
  const initialValues = product

  return <ParentInput {...{ initialValues, canEdit, mutationConfig: productQueries.updateConfig, name, ...rest }} />
}
